/**
 * Ticket type aliases – mirror backend CrmCommunicationTicketWorkflowPayloadService::crmLevelTypeAliasesForTicketType().
 */

/** Oznam (vrátane legacy aliasu notice) – parita ServiceTask Info. */
export function isCrmAnnouncementTicket(ticketType) {
  const type = String(ticketType || '').trim();
  return type === 'announcement' || type === 'notice';
}

export function crmLevelTypeAliasesForTicketType(ticketType) {
  const type = String(ticketType || '').trim();
  switch (type) {
    case 'announcement':
      return ['announcement', 'notice'];
    case 'quote_request':
      return ['quote_request', 'inquiry'];
    case 'acquisition':
      return ['acquisition'];
    default:
      return type ? [type] : [];
  }
}

export function crmLevelTypeMatchesTicketType(levelType, ticketType) {
  const aliases = crmLevelTypeAliasesForTicketType(ticketType);
  return aliases.includes(String(levelType || '').trim());
}

export function crmStateMatchesTicketType(applicableTypes, ticketType) {
  if (!Array.isArray(applicableTypes) || applicableTypes.length === 0) {
    return true;
  }
  const aliases = crmLevelTypeAliasesForTicketType(ticketType);
  return applicableTypes.some((t) => aliases.includes(String(t || '').trim()));
}

/** Workflow stavy z crm_states podľa phase (+ ticket type). */
export function filterCrmWorkflowStatesByPhase(states, phase, ticketType) {
  const phaseKey = String(phase || '').trim();
  return (Array.isArray(states) ? states : [])
    .filter((row) => row?.active !== false)
    .filter((row) => String(row?.phase || '') === phaseKey)
    .filter((row) => {
      const types = Array.isArray(row?.applicable_types) ? row.applicable_types : null;
      return crmStateMatchesTicketType(types, ticketType);
    })
    .sort((a, b) => Number(a?.sort_order || 0) - Number(b?.sort_order || 0));
}

/** Kroky vykonania z crm_steps – rovnaké filtrovanie ako katalóg step_definitions. */
export function filterCrmStepsForTicketType(steps, ticketType) {
  return (Array.isArray(steps) ? steps : [])
    .filter((row) => row?.active !== false)
    .filter((row) => {
      const types = Array.isArray(row?.applicable_types) ? row.applicable_types : null;
      return crmStateMatchesTicketType(types, ticketType);
    })
    .sort((a, b) => Number(a?.sort_order || 0) - Number(b?.sort_order || 0));
}
